import React, { createContext, useContext, useState } from 'react'
import { THEMES } from '../config/themes.js'

export const ThemeContext = createContext(null)

export function ThemeProvider({ children }) {
  const [themeName, setThemeName] = useState(() => {
    return localStorage.getItem('softly-theme') || 'light'
  })

  function setTheme(key) {
    if (!THEMES[key]) return
    localStorage.setItem('softly-theme', key)
    setThemeName(key)
  }

  const theme = THEMES[themeName] || THEMES.light

  return (
    <ThemeContext.Provider value={{ themeName, setTheme, theme }}>
      {children}
    </ThemeContext.Provider>
  )
}

export function useThemeContext() {
  return useContext(ThemeContext)
}
